import axiosPost from '../axiosPost';

export const tarjetasAcreditacionesAcreditar = async (arg) => {
    const { params } = arg

    const body = {
        "service": "GWCardAcreditacionPorMerchantDo",
        "params": params
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}